<div class="text-center">
<img src='/assets/1.png' class="onboarding-img" alt='image'>
<div class="text-center ml-auto mr-auto w-50">
    <h1>Improve Your Sleep</h1>
    <p>
        See lasting results with Cognitive behavioral therapy for insomnia (CBTi) that can benefit anyone with sleep
        problems.
    </p>
</div>
</div>